import axios from 'axios'
import { ForbiddenError, ResponseError } from './errorHandler'

export type AuthToken = {
  access_token: string
  expires_in: string
  refresh_token: string
}

const authTokenIdentifier = 'X-GigbaseBizToken'
export const setAuthToken = (token: AuthToken) =>
  window.localStorage.setItem(authTokenIdentifier, token.access_token)
const getAuthToken = () => window.localStorage.getItem(authTokenIdentifier)
export const clearAuthToken = () =>
  window.localStorage.removeItem(authTokenIdentifier)

const axiosForGigbaseBiz = axios.create({
  baseURL: [
    process.env.NEXT_PUBLIC_GIG_BIZ_API_BASE_URL,
    process.env.NEXT_PUBLIC_GIG_BIZ_API_VERSION,
  ].join('/'),
})

export const axiosForGigbaseBizMock = axios.create({
  baseURL: 'http://localhost:8082',
})

axiosForGigbaseBiz.defaults.headers.post['Content-Type'] =
  'application/json;charset=utf-8'

axiosForGigbaseBiz.interceptors.request.use((config) => {
  config.headers = {
    ...config.headers,
    accept: 'application/json',
    [authTokenIdentifier]: getAuthToken() || '',
  }
  return config
})

axiosForGigbaseBiz.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (axios.isAxiosError(error)) {
      const response = error.response
      if (response === undefined) {
        return Promise.reject(error)
      }
      if (response.status == 403) {
        return Promise.reject(
          new ForbiddenError(
            response.status,
            response.data.error?.messages
              ? response.data.error.messages
              : '閲覧権限がありません',
          ),
        )
      }
      if (
        response.data.error?.messages !== undefined &&
        response.data.error.messages.length > 0
      ) {
        return Promise.reject(
          new ResponseError(response.status, response.data.error.messages),
        )
      }
      if (response.status >= 400) {
        return Promise.reject(new ResponseError(response.status, error.message))
      }
      // TODO: sentry
    }
    return Promise.reject(error)
  },
)

export default axiosForGigbaseBiz
